import type { MultiSelectOption } from '@/components/multi-select-field';

/**
 * Manufacturer filter options. There is no manufacturer list API; this static
 * set matches the BFF's ManufacturerPrefix -> index-code map (MDT/BSX/BIO
 * identity, ABT -> STJ). Shared by the All Patients roster filters and the
 * billing tables' Device facet so both offer the exact same vocabulary (both
 * resolve in the same patient-search query).
 */
export const MANUFACTURER_OPTIONS: MultiSelectOption[] = [
  { value: 'MDT', label: 'Medtronic' },
  { value: 'BSX', label: 'Boston Scientific' },
  { value: 'ABT', label: 'Abbott' },
  { value: 'BIO', label: 'Biotronik' },
];
